// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-modules-Image-style----general-module---container---1v2A0 overflow-hidden width-100","block":"src-components-modules-Image-style----general-module---block---3Q3in centered display-block","inlineBlock":"src-components-modules-Image-style----general-module---inlineBlock---1FbhZ display-inlineBlock","shadow":"src-components-modules-Image-style----general-module---shadow---TCYYx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Image/style/general.module.css
// module id = 1477
// module chunks = 168707334958949